import * as React from "react";
import { DataLayer, AlgoliaAnalyticsHelpers } from "@grandvisionhq/analytics";
import { RangeSlider } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useAlgoliaConfig } from "../../../../../Algolia/AlgoliaConfig.js";
/* empty css                          */
const renderNumberInitial = (v) => v;
const FacetInputPriceRange = ({
  min,
  max,
  value,
  facetLabel,
  onChange,
  renderNumber = renderNumberInitial
}) => {
  const { indexName } = useAlgoliaConfig();
  const { currency, getLabel } = useIntl();
  const [range, setRange] = React.useState(value);
  const handleAfterChange = ([min2, max2]) => {
    if (min2 && max2) {
      onChange({ min: min2, max: max2 });
    }
    DataLayer.pushEvent({
      event: "filter_applied",
      filter_type: facetLabel,
      filter_value: { min: min2, max: max2 }
    });
    if (min2 && max2) {
      const encodedFacetLabel = encodeURIComponent(facetLabel);
      const encodedRangeValue = encodeURIComponent(`${min2} TO ${max2}`);
      const filterString = `${encodedFacetLabel}:${encodedRangeValue}`;
      AlgoliaAnalyticsHelpers.sendFilterAppliedEvent([filterString], indexName);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "facet-input-price-range" }, /* @__PURE__ */ React.createElement(
    RangeSlider,
    {
      value: [range.min, range.max],
      min,
      max,
      currency,
      onChange: ([min2, max2]) => {
        if (min2 && max2) {
          setRange({ min: min2, max: max2 });
        }
      },
      onChangeComplete: handleAfterChange,
      renderNumber,
      ariaLabel: getLabel("search.filters.pricerange.select", {
        defaultValue: "Select a price range"
      })
    }
  ));
};
export {
  FacetInputPriceRange as default
};
//# sourceMappingURL=FacetInputPriceRange.js.map
